import { render, staticRenderFns } from "./SmartbonesNews.vue?vue&type=template&id=2a506a9e&scoped=true"
import script from "./SmartbonesNews.vue?vue&type=script&lang=js"
export * from "./SmartbonesNews.vue?vue&type=script&lang=js"
import style0 from "./SmartbonesNews.vue?vue&type=style&index=0&id=2a506a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a506a9e",
  null
  
)

export default component.exports